// extracted by mini-css-extract-plugin
export default {"create-group-form":"styles__create-group-form___K0pFK","half-width-left":"styles__half-width-left___Y3vv_","readOnly":"styles__readOnly___fhHh4"};